// NB: we do not import any actual functions here so we can load this module without loading the rest of the SDK
import type auth0 from "auth0-js";

import { addDevVars } from "@/dev/initDev.ts";
import { auth0DomainCheckAtom, auth0OptionsAtom } from "@/modules/login/auth0/auth0Config.ts";
import { makeOnce } from "@warrenio/utils/makeOnce";
import { atom } from "jotai/vanilla";

const importAuth0 = makeOnce(() => import("auth0-js"));

export const webAuthAtom = atom<Promise<auth0.WebAuth>>(async (get) => {
    // Check domain
    get(auth0DomainCheckAtom).warnIfInvalid();

    // Construct
    const auth0 = await importAuth0();
    const webAuth = new auth0.WebAuth(get(auth0OptionsAtom));

    // Debug
    addDevVars({ webAuth });

    return webAuth;
});
